module.exports = window.jQuery;


//////////////////
// WEBPACK FOOTER
// external "window.jQuery"
// module id = 0iPh
// module chunks = gutenberg customizer customizer-fonts blog app admin